import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TeacherDashboard from '../dashboards/TeacherDashboard';
import TeacherContent from './TeacherContent';
import TeacherGrades from './TeacherGrades';
import TeacherSubjects from './TeacherSubjects';
import CourseCreationWizard from './CourseCreationWizard';
import TeacherCourseManagement from './TeacherCourseManagement';

const TeacherRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<TeacherDashboard />} />
      <Route path="/content" element={<TeacherContent />} />
      <Route path="/grades" element={<TeacherGrades />} />
      <Route path="/subjects" element={<TeacherSubjects />} />
      <Route path="/create-course" element={<CourseCreationWizard />} />
      <Route path="/courses/:courseId" element={<TeacherCourseManagement />} />
      <Route path="/courses/:courseId/edit" element={<CourseCreationWizard />} />
    </Routes>
  );
};

export default TeacherRoutes;
